import {
  useState,
  useEffect,
  FC,
  useMemo,
  useRef,
  useLayoutEffect,
} from 'react';

import { Empty } from 'antd';

import 'react-base-table/styles.css';
import _ from 'lodash';
import moment from 'moment';
import BaseTable from 'react-base-table';
import { v4 as uuidv4 } from 'uuid';

import ExpandIcon from './components/ExpandIcon';
import GroupCell from './components/GroupCell';
import GroupHeader from './components/GroupHeader';
import HeaderCell from './components/HeaderCell';
import {
  findObjectById,
  getSummaryOfGroupings,
} from '../../../../../helpers/utils/functions';
import {
  checkConvertDataType,
  checkMoneyDataType,
  formatConvertData,
  formatMoneyData,
  finishRows,
  checkPercentDataType,
} from '../../../../../helpers/utils/reports';
import {
  getCustomMetricRow,
} from '../../../../../helpers/utils/tableHelpers';
import { showErrorMessage } from '../../../../../helpers/utils/ui';
import { unApi } from '../../../api/endpoints/reports/unApi';
import { findTopParentObjectName } from '../../../constants/reports';
import { useActions } from '../../../hooks/useActions';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import Loading from '../../loader/Loader';
const COL_GROUP_MINWIDTH = 260;
const COL_WIDTH = 120;
const COL_MIN_WIDTH = 120;
const COL_MAX_WIDTH = 900;
let HEADER_HEIGHT = 110;

const UniversalTable: FC<any> = (props) => {
  const prevReqDataRef = useRef({ isLoad: false, data: '' });
  const {
  hidePersonalDataGroups = null,
  blockId = null,
  isShow = false,
  display,
  isDashboard = null,
  isModal = false
  } = props;
  const period = useTypedSelector((state) => state.period);
  const attrDashboard = useTypedSelector(
    (state) => isModal ? state.attributes.attributes : state.attributes.attributesDashboard
  );
  const { filters } = useTypedSelector((state) =>
    blockId && !isModal ? state.filter.blocks[blockId] ?? { filters: [] } : isModal? state.filter.dashboardModal : state.filter
  );
  const filtersStorageValue =
    JSON.parse(localStorage.getItem('dashboardFilters') || '') || [];
  const withCheckbox = display === 'chart';

  const { filters: commonFilter } = useTypedSelector((state) =>
    blockId
      ? isShow
        ? state.filter
        : filtersStorageValue
      : filtersStorageValue
  );
  const commonFilters =
    commonFilter?.length === 0 && isShow ? filtersStorageValue : commonFilter;
  const { selectedSchool, schoolDetail } = useTypedSelector((state) => state.currentSchool);
  const {
    isCompare,
    isTableLoading,
    isTableFetching,
    currency,
    isTableCompareFetching,
  } = useTypedSelector((state) => blockId ? state.meta.blocks[blockId] : state.meta);

  const { isAllBlocksFetching, isModalTableFetching } = useTypedSelector((state) => state.meta);
  const { chartType } = useTypedSelector((state) => state.chart);
  const {
    groupings,
    metrics,
    percentages,
    filtersTable,
    sortTable,
    groupsChecked,
    metricsChecked,
    totalChecked,
  } = useTypedSelector((state) =>
    blockId && !isModal ? state.table.blocks[blockId] : state.table
  );
  const { tableData } = useTypedSelector((state) => blockId ? state.table.blocks[blockId] : state.table);
  const { compareFilters, comparePeriod } = useTypedSelector(
    (state) => state.compare
  );
  const {
    setMetaTableLoading,
    setGroupsLimit,
    setMetricsLimit,
    setTableData,
    setTableChildrenData,
    setMetaCompareTableFetching,
    setMetaTableFetching,
    setSortTable,
    setTotalChosenMetrics,
    setTotalChosenStatus,
    getCreatedMetrics,
    setMetaModalTableFetching
  } = useActions();

  const [ dimensionsTable, setDimensionsTable ] = useState({ height: 0 });
  const [ data, setData ] = useState([]);
  const [ frozensColumns, setFrozensColumns ] = useState<any>({});
  const [ expandedRowKeys, setExpandedRowKeys ] = useState<any>([]);
  const downloadedRowKeys = useRef<string[]>([]);
  const [ loadRowKeys, setLoadRowKeys ] = useState<any>([]);
  const [ tableWidth, setTableWidth ] = useState(1200);
  const [ columnsTable, setColumnsTable ] = useState<any>([]);
  const [ expandedAll, setExpandedAll ] = useState<string[]>([]);
  const tableDiv = document.getElementById(`table-${blockId}`);

  const handleGroupsChanged = (
    _groupsChecked: any,
    _metricsChecked: any,
    _totalChecked: any,
    _chartType: string
  ) => {
    if (_chartType === 'bubble') {
      setMetricsLimit(false);
      setGroupsLimit(false);
      return;
    }

    if (_groupsChecked.length > 0) {
      if (_totalChecked.length > 0) {
        setMetricsLimit(true);
      } else {
        if (_groupsChecked.length > 1) {
          setMetricsLimit(true);
        } else {
          setMetricsLimit(true);
        }
      }
    } else {
      setMetricsLimit(false);
    }

    if (_metricsChecked?.length > 1) {
      setGroupsLimit(true);
    } else {
      setGroupsLimit(false);
    }
  };

  useEffect(() => {
    handleGroupsChanged(groupsChecked, metricsChecked, totalChecked, chartType);
  }, [ groupsChecked, metricsChecked, totalChecked, chartType ]);

  useEffect(() => {
    if (tableDiv && !blockId) {
      const calcTableWidth = () => {
        const width = tableDiv.offsetWidth;
        setTableWidth(width <= 1000 ? 1000 : width);
      };

      new ResizeObserver(calcTableWidth).observe(tableDiv);
      calcTableWidth();
    }
    if (blockId) {
      const calculateWidth = () => {
        return metrics?.length * 120 + 260;
      };
      setTableWidth(calculateWidth());
    }
  }, [ tableDiv, blockId, metrics?.length ]);

  const loadCompareRows = (loadCurrent?: any) => {
    setMetaTableLoading({ value: true, blockId });
    const { compareFilters1, compareFilters2 } = compareFilters;
    const { comparePeriod1, comparePeriod2 } = comparePeriod;
    const { attribution } =
    attrDashboard?.attribution[0] === 'blocks'
    ? props.attribution ?? { attribution: '1' }
    : attrDashboard;
    const { type_applications } =
    attrDashboard?.type_applications[0] === 'blocks'
    ? props.attribution ?? { type_applications: '2' }
    : attrDashboard;

    const format = 'YYYY-MM-DD';
    const groupings_names = groupings.map((col) => col.dataKey);
    const metrics_names = metrics.map((col) => col.dataKey);
    const expanded_ids = loadCurrent ? loadCurrent?.clientData?.path : [];

    const _comparePeriod1 = {
      start: moment(comparePeriod1.start).format(format),
      end: moment(comparePeriod1.end).format(format),
    };
    const _comparePeriod2 = {
      start: moment(comparePeriod2.start).format(format),
      end: moment(comparePeriod2.end).format(format),
    };

    const data = {
      comparePeriod1: _comparePeriod1,
      comparePeriod2: _comparePeriod2,
      compareFilters1: compareFilters1,
      compareFilters2: compareFilters2,
      attribution: {
        attribution: attribution,
        type_applications: type_applications,
      },
      groupings_names,
      metrics_names,
      expanded_ids,
    };
    const prevRequestState = window.localStorage.getItem('prevRequestState');
    let parsedPrevState = {};
    if (prevRequestState) {
      parsedPrevState = JSON.parse(prevRequestState);
    }
    if (_.isEqual(data, parsedPrevState)) {
      setMetaTableLoading({ value: false, blockId });
      return;
    }
    //Избегаем лишних запросов, если data не изменилась
    if(prevReqDataRef.current.data === JSON.stringify(data) && prevReqDataRef.current.isLoad) {
      return;
    }else if(prevReqDataRef.current.data === JSON.stringify(data)) {
      isModal && setMetaModalTableFetching({ value: false });
      setMetaTableFetching({ value: false, blockId });
      setMetaTableLoading({ value: false, blockId });
      return;
    }
    prevReqDataRef.current.isLoad = true;

    window.localStorage.setItem('prevRequestState', JSON.stringify(data));
    unApi
    .getUniversalReportTableData(data, location.pathname)
    .then((response) => {
      const data = response.data;
  
      if (data.success) {
        const transformedData = data.data.map((item: any) => { // Доступ к data.data (если data содержит массив в поле data)
          const dateParts = item.group.split('.'); // ["день", "месяц", "год"]
          const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`; // "год-месяц-день"
          
          return {
            ...item,
            group: new Date(formattedDate), // Преобразуем в объект Date для корректной сортировки
          };
        });
      
        // Теперь сортируем данные по дате
        transformedData.sort((a: any, b: any) => a.group.getTime() - b.group.getTime());
      
        // Если необходимо вернуть обратно строковый формат даты:
        transformedData.forEach((item: any) => {
          item.group = item.group.toLocaleDateString('ru-RU'); // Преобразуем обратно в "DD.MM.YYYY"
        });
      
  
        if (loadCurrent) {
          setTableChildrenData({ loadCurrent, data: transformedData, groupings, blockId });
          setExpandedRowKeys((prev: any) => [ ...prev, loadCurrent.pathStr2 ]);
          setLoadRowKeys((prev: any) =>
            prev.filter((item: any) => item !== loadCurrent.pathStr2)
          );
        } else {
          setTableData({ ...data, groupings, blockId });
          setExpandedRowKeys([]);
          setLoadRowKeys([]);
        }
      } else {
        if (response.status === 504) {
          showErrorMessage(
            'Запрос выполняется слишком долго, из-за большого количества данных. Можно уменьшить период отчёта, удалить не нужные метрики или фильтры.'
          );
        }
  
       
      }
    })
    .catch((error) => {
      if (error?.response?.status !== 401) {
        showErrorMessage('Ошибка при получении данных');
      }
    }).finally(()=>{
      prevReqDataRef.current = { isLoad: false, data: JSON.stringify(data) };
      isModal && setMetaModalTableFetching({ value: false });
      setMetaCompareTableFetching({ value: false, blockId });
      setMetaTableLoading({ value: false, blockId });     
  });
  };

  const loadRows = (loadCurrent?: any) => {
    setMetaTableLoading({ value: true, blockId });
    let __attribution = (
      attrDashboard?.attribution?.[0] === 'blocks'
        ? props.attribution
        : attrDashboard
    )?.attribution;
    let __type_app = (
      attrDashboard?.type_applications?.[0] === 'blocks'
        ? props.attribution
        : attrDashboard
    )?.type_applications;
    let __period = period;
    const format = 'YYYY-MM-DD';
    const _period = {
      start: moment(__period.start).format(format),
      end: moment(__period.end).format(format),
    };
    const groupings_names = groupings.map((col: any) => col.dataKey);
    const metrics_names = metrics.map((col) => col.dataKey);
    const expanded_ids = loadCurrent ? loadCurrent.clientData.path : [];

    if (expanded_ids.length === groupings_names.length) {
      localStorage.setItem(
        'lastLoadDateTime',
        JSON.stringify({ time: new Date().toString(), completed: true })
      );
      return;
    }
    let data = {
      period: _period,
      filters: [ ...filters, ...(isShow ? commonFilters : []) ],
      attribution: {
        attribution:
          typeof __attribution === 'string' ? [ __attribution ] : __attribution,
        type_applications:
          typeof __type_app === 'string' ? [ __type_app ] : __type_app,
      },
      groupings_names: props?.selectedGroupings?.map((group: any) => {
        return group.dataKey;
      }) ?? groupings_names,
      metrics_names: props?.selectedMetrics?.map((metric: any) => {
        return metric.dataKey;
      }) ?? metrics_names,
      expanded_ids,
    };

    //Избегаем лишних запросов, если data не изменилась
    if(prevReqDataRef.current.data === JSON.stringify(data) && prevReqDataRef.current.isLoad) {
      return;
    }else if(prevReqDataRef.current.data === JSON.stringify(data)) {
      isModal && setMetaModalTableFetching({ value: false });
      setMetaTableFetching({ value: false, blockId });
      setMetaTableLoading({ value: false, blockId });
      return;
    }
    prevReqDataRef.current.isLoad = true;

    window.localStorage.setItem('prevRequestState', JSON.stringify(data));
    unApi
      .getUniversalReportTableData(data, location.pathname)
      .then((response) => {
        const rowsWithIdAsString = response.data?.rows?.map((row: any) => {
          if (row.id) {
            return { ...row, id: row.id.toString() };
          }
          return row;
        });

        const data = { ...response.data, rows: rowsWithIdAsString };
        if (data.success) {
          if (loadCurrent) {
            setTableChildrenData({ loadCurrent, data, groupings, blockId });
            setExpandedRowKeys((prev: any) => [ ...prev, loadCurrent.pathStr2 ]);
            setLoadRowKeys((prev: any) =>
              prev.filter((item: any) => item !== loadCurrent.pathStr2)
            );
          } else {
            setExpandedRowKeys([]);
            setLoadRowKeys([]);
            setTableData({ ...data, groupings, blockId });
          }
        } else {
          //showErrorMessage("Ошибка при получении данных")
          if (response.status === 504) {
            showErrorMessage(
              'Запрос выполняется слишком долго, из-за большого количества данных. \n Можно уменьшить период отчёта, удалить ненужные метрики или фильтры.'
            );
          }
        }
        if (Object.keys(sortTable).length === 0) {
          setSortTable({ random: 'Sd' });
          setSortTable({});
        }
      })
      .catch((error) => {
        if (error?.response?.status !== 401) {
            showErrorMessage('Ошибка при получении данных');
        }
        if (error.response) {
          if (error.response.status === 504) {
            showErrorMessage(
              'Запрос выполняется слишком долго, из-за большого количества данных. \n Можно уменьшить период отчёта, удалить ненужные метрики или фильтры.'
            );
          }
        }
        setData([]);

      }).finally(()=>{
          prevReqDataRef.current = { isLoad: false, data: JSON.stringify(data) };
          isModal && setMetaModalTableFetching({ value: false });
          setMetaTableFetching({ value: false, blockId });
          setMetaTableLoading({ value: false, blockId });
    });
  };

  useEffect(() => {
    window.localStorage.setItem('prevRequestState', JSON.stringify({}));
    if (selectedSchool?.id) {
      getCreatedMetrics(selectedSchool?.id, '/users/universal');
    }
  }, []);
  useEffect(() => {
    if (groupsChecked.length === 0) {
      let initialChosenMetrics: any = {};
      metrics.forEach((el) => {
        initialChosenMetrics[el.dataKey] = 0;
      });
      setTotalChosenMetrics(initialChosenMetrics);
      setTotalChosenStatus([]);
    } else {
      const result = getSummaryOfGroupings(groupsChecked, data);

      result ? setTotalChosenMetrics(result) : null;
    }
  }, [ groupsChecked, data.length ]);
  useLayoutEffect(() => {
    if((isAllBlocksFetching && !isModal) || (isModal && isModalTableFetching) || (!isTableFetching && !isModal) || (!isTableCompareFetching && !isModal)) {
      if (isCompare) {
        loadCompareRows();
        return;
      } else {
        loadRows();
        return;
      }
    }
  }, [
    isTableFetching,
    isTableCompareFetching,
    isModal ? isModalTableFetching : null,
    isAllBlocksFetching
  ]);

  useEffect(() => {
    const docEl = document.documentElement;
    setDimensionsTable({
      height: docEl.clientHeight - 150,
    });
  }, [ tableWidth ]);
  const isGroupsChanged = useRef(false);
  const widthGroupCol = useMemo(() => {
    let width = tableWidth - 20 - metrics?.length * COL_WIDTH;
    return width > COL_GROUP_MINWIDTH ? width : COL_GROUP_MINWIDTH;
  }, [ tableWidth, metrics?.length ]);
  const [ columnWidth, setColumnWidth ] = useState<number>(widthGroupCol);
  const handleCellWidthChange = (width: number) => {
    if (isGroupsChanged.current) {
      isGroupsChanged.current = false;
      return;
    }
    setColumnWidth((prev) =>
      width > COL_GROUP_MINWIDTH && width > prev
        ? width
        : prev > COL_GROUP_MINWIDTH
        ? prev
        : COL_GROUP_MINWIDTH
    );
  };
  useEffect(() => {
    let width = tableWidth - 20 - metrics?.length * COL_WIDTH;
    setColumnWidth(width > COL_GROUP_MINWIDTH ? width : COL_GROUP_MINWIDTH);
    isGroupsChanged.current = true;
  }, [ groupings ]);
  const columnsWidth = useMemo(() => {
    if (isCompare) {
        const result: any = {};
        const elements = document.getElementsByClassName('column-span');

        for (let i = 0; i < elements.length; i++) {
          result[elements[i].classList[1]] = Math.max(
            elements[i].getBoundingClientRect().width,
            !result[elements[i].classList[1]]
              ? 0
              : result[elements[i].classList[1]]
          );
        }
        for (const key in result) {
          result[key] = result[key] + 40;
        }
        return result;
    }
    return {};
  }, [ isCompare ]);
  useEffect(() => {
    let _data = [];
      _data = [
        {
          title: 'Группа',
          dataKey: 'group',
          key: 'group',
          width: 260,
          minWidth: COL_GROUP_MINWIDTH,
          maxWidth: COL_MAX_WIDTH,
          frozen: 'left',
          resizable: true,
          groupings: props?.selectedGroupings ?? groupings,
          sortTable,
          loadRowKeys,
          columnWidth,
          withCheckbox,
          headerRenderer: () => (
            <GroupHeader
              withCheckbox={withCheckbox}
              blockId={isModal? null : blockId}
              sort={sortTable}
              dataKey={'group'}
            />
          ),
          cellRenderer: ({ rowData }: any) => (
            <GroupCell
              withCheckbox={withCheckbox}
              rowData={rowData}
              expandedRowKeys={expandedRowKeys}
              onCellWidthChange={handleCellWidthChange}
            />
          ),
        },
        ...(props?.selectedMetrics ?? metrics).map((item: any) => {
          const { name, description, dataKey } = item;
          return {
            title: name,
            description,
            dataKey,
            background: item?.background,
            item,
            plan: item?.plan,
            base_metric_name: item?.base_metric_name,
            metric_formula: item?.metric_formula,
            key: dataKey,
            width:
              columnsWidth[dataKey] > COL_WIDTH
                ? columnsWidth[dataKey]
                : COL_WIDTH,
            minWidth: COL_MIN_WIDTH,
            maxWidth: COL_MAX_WIDTH,
            resizable: true,
            filtersTable,
            sortTable,
            columnsWidth,
            frozen: frozensColumns[dataKey] || false,
            headerRenderer: ({ column }: any) => {
              return (
        
                <HeaderCell
                  blockId={blockId}
                  column={column}
                  filters={filtersTable}
                  sort={sortTable}
                  setFrozens={setFrozensColumns}
                  item={item}
                />
              );
            },
            cellRenderer: (renderItem: any) => {
              if (checkPercentDataType(dataKey)) {
                return (
                  <span
                    style={{
                      textAlign: 'right',
                      width: '100%',
                      paddingRight: '4px',
                    }}
                  >
                    {formatConvertData(renderItem.cellData, dataKey)}
                  </span>
                );
              }
              if (dataKey === 'ads_spend') {
                if (renderItem.cellData) {
                  // const formatted = Number(renderItem.cellData).toFixed(2).toString()

                  return (
                    <span
                      style={{
                        textAlign: 'right',
                        width: '100%',
                        paddingRight: '4px',
                      }}
                    >
                      {formatMoneyData(renderItem.cellData, currency || schoolDetail?.currency?.symbol || '', dataKey)}
                    </span>
                  );
                }
              }
              if (checkMoneyDataType(dataKey)) {
                return (
                  <span
                    style={{
                      textAlign: 'right',
                      width: '100%',
                      paddingRight: '4px',
                    }}
                  >
                    {formatMoneyData(renderItem.cellData, currency || schoolDetail?.currency?.symbol || '', dataKey)}
                  </span>
                );
              }
              if (checkConvertDataType(dataKey)) {
                return (
                  <span
                    style={{
                      textAlign: 'right',
                      width: '100%',
                      paddingRight: '4px',
                    }}
                  >
                    {formatConvertData(renderItem.cellData, dataKey)}
                  </span>
                );
              }
              return getCustomMetricRow(
                dataKey,
                renderItem,
                item,
                currency || schoolDetail?.currency?.symbol || '',
                data
              );
            },
          };
        }),
      ];

    setColumnsTable(_data);
  }, [
    display,
    columnsWidth,
    columnWidth,
    props?.selectedGroupings,
    props?.selectedMetrics,
    metrics,
    isCompare,
    groupings,
    widthGroupCol,
    filtersTable,
    sortTable,
    frozensColumns,
  ]);

  useEffect(() => {
    const _data = finishRows({
      rows: tableData.data,
      filters: filtersTable,
      sort: sortTable,
      percentages,
      totalRow: tableData.total,
      totalChoosenRow: tableData.totalChosen.metrics,
    });
    const temp = _data.map((el: any) => {
      if (el.pathStr === 'total') {
        el.pathStr2 = 'total';
      } else if (el.group === 'empty') {
        el.pathStr2 = uuidv4();
      } else if (el.pathStr === 'total_choosen') {
        el.pathStr2 = 'total_choosen';
      }
      return { ...el, uniqueKey: uuidv4() };
    }); //adding keys
    setData(temp);
  }, [
    tableData.data,
    tableData.total,
    tableData.totalChosen.metrics,
    filtersTable,
    sortTable,
    percentages,
    expandedRowKeys,
  ]);

  const processChildren = (children: any) => {
    children.forEach((el: any) => {
      if (!Array.isArray(el.children)) return;
      if (!el?.clientData?.downloaded) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (downloadedRowKeys.current.includes(el.pathStr2)) {
          return;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (!downloadedRowKeys.current.includes(el.pathStr2)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          downloadedRowKeys.current = [
            ...new Set([ ...downloadedRowKeys.current, el.pathStr2 ]),
          ];
        }
        if (!loadRowKeys.includes(el.pathStr2)) {
          setLoadRowKeys((prev: any) => [ ...prev, el.pathStr2 ]);
        }
        if (isCompare) {
          // loadCompareRows(rowData);
        } else {
          // setTimeout(() => {
            //loadRows(el);
          // }, 1000);
        }
        setMetaTableFetching({ value: false, blockId });
      } else {
        if (!expandedRowKeys.includes(el.pathStr2)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          setExpandedRowKeys((prev: any) => [
            ...new Set([ ...prev, el.pathStr2 ]),
          ]);
        }
      }

      if (el.children && el.children.length > 0) {
        processChildren(el.children);
      }
    });
  };

  const handleExpandIconProps = ({ rowData }: any) => {
    try {
      if (!Array.isArray(tableData.data)) {
        return;
      }

      tableData.data.forEach((el, index) => {
        if (!Array.isArray(el.children)) return;

        el.children.forEach((childEl: any) => {
          const parentPathStr2 = tableData.data[index]?.pathStr2;
          
          if (!expandedAll.includes(parentPathStr2 || '')) return;

          if (!rowData?.clientData?.downloaded) {
            // Обработка новых данных
            if (!downloadedRowKeys.current.includes(childEl.pathStr2)) {
              downloadedRowKeys.current = [
                ...new Set([ ...downloadedRowKeys.current, childEl.pathStr2 ])
              ];
              
              setLoadRowKeys((prev: any) => [ ...prev, childEl.pathStr2 ]);
              
              if (!isCompare) {
                setTimeout(() => {
                  if (!expandedRowKeys.includes(childEl.pathStr2)) {
                    loadRows(childEl);
                  }
                }, 1000);
              }
              setMetaTableFetching({ value: false, blockId });
            }
          } else {
            // Обработка уже загруженных данных
            if (!expandedRowKeys.includes(childEl.pathStr2)) {
              setExpandedRowKeys((prev: any) => [
                ...new Set([ ...prev, childEl.pathStr2 ])
              ]);
            }
          }

          // Обработка вложенных children
          if (Array.isArray(childEl.children)) {
            processChildren(childEl.children);
          }
        });
      });

      if (rowData.pathStr2 === 'total' || rowData.pathStr2 === 'total_choosen') {
        return;
      }
    } catch (err) {
      console.error('Error in handleExpandIconProps:', err);
    }
  };

  const isSort = () => Object.values(sortTable)[0] === 'ASC';

  const headerHeightValue = withCheckbox ? HEADER_HEIGHT + 30 : HEADER_HEIGHT;
  const memoTable = useMemo(() =>(
    <BaseTable
    fixed
    columns={columnsTable}
    data={JSON.parse(JSON.stringify(data))} 
    rowKey="pathStr2"
    width={tableWidth}
    maxHeight={
      blockId && !isDashboard
        ? Math.max(data?.length * 38 + 260, 150)
        : dimensionsTable.height
    }
    minHeight={
      blockId && !isDashboard
        ? document.getElementById(`component-${blockId}`)
            ?.offsetHeight || 300
        : 300
    }
    headerHeight={
      Object.keys(filtersTable).length > 0
        ? headerHeightValue + 15
        : headerHeightValue
    }
    style={{
      minHeight: blockId && !isDashboard ? document.getElementById(`component-${blockId}`)
            ?.offsetHeight || 300
        : 300,
    }}
    estimatedRowHeight={70}
    expandColumnKey="group"
    expandIconProps={({ rowData }: any) => {
      handleExpandIconProps({ rowData });
      return {
        pathStr2: rowData.pathStr2,
        expandable: !!rowData.children,
        loading: downloadedRowKeys.current.includes(rowData.pathStr2)
          ? false
          : loadRowKeys.includes(rowData.pathStr2),
        downloaded: rowData.clientData && rowData.clientData.downloaded,
      };
    }}
    onRowExpand={({ expanded, rowData, rowKey }: any) => {
      if (!rowData.clientData.downloaded) {
        setLoadRowKeys((prev: any) => [ ...prev, rowKey ]);
        if (isCompare) {
          loadCompareRows(rowData);
        } else {
          loadRows(rowData);
        }

        setMetaTableFetching({ value: false, blockId });
      } else {
        if (expanded)
          setExpandedRowKeys((prev: any) => [ ...prev, rowKey ]);
        else
          setExpandedRowKeys((prev: any) =>
            prev.filter((item: any) => item !== rowKey)
          );
      }
    }}
    expandedRowKeys={expandedRowKeys}
    components={{
      ExpandIcon: (props) => {
        return (
          <ExpandIcon {...props} setExpandedAll={setExpandedAll} />
        );
      },
    }}
    disabled={isTableLoading}
    rowRenderer={({ rowData, cells }: any) => {
      const customStyle = {
        height: '38px',
       
      };
      if (rowData.group === 'empty') {
        rowData.pathStr2 = uuidv4();
        const parent = findObjectById(data, rowData.parentId);
        if (parent) {
          const parentName: string = findTopParentObjectName(
            groupings[parent.clientData.path.length].name
          );
          return (
            <>
              <div
                className="table-row-empty"
                style={{ ...customStyle }}
              >
                <span
                  style={{
                    color: 'rgb(196,196,196',
                    fontSize: '9px',
                    minWidth: '120px',
                    position: 'absolute',
                    top: 0,
                    left: 10,
                  }}
                >
                  {groupings[parent.clientData.path.length].name}
                </span>
                <Empty
                  style={{ paddingTop: 16 }}
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={false}
                  imageStyle={{ height: 27, marginBottom: 0 }}
                />
                {parentName ||
                  'Нет данных, соответствующих условиям отчёта.'}
              </div>
            </>
          );
        } else {
          return (
            <div className="table-row-empty" style={customStyle}>
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={false}
                imageStyle={{ height: 27, marginBottom: 0 }}
              />
              Нет данных, соответствующих условиям отчёта.
            </div>
          );
        }
      }
      if (
        rowData.pathStr2 === 'total' ||
        rowData.pathStr2 === 'total_choosen'
      ) {
        return (
          <div
            className="BaseTable__row BaseTable__header-row"
            style={customStyle}
          >
            {cells}
          </div>
        );
      }
      return (
        <div className="BaseTable__row" style={customStyle}>
          {cells}
        </div>
      );
    }}
  />
  ), [
    columnsTable,
    isTableLoading,
    widthGroupCol,
    hidePersonalDataGroups,
    isSort,
  ]);
    return (
      <div
        className={`universal-table ${
          blockId && !isDashboard ? 'dashboards-table' : 'previewTable'
        }`}
        style={{
          border: isShow ? '' : '',
          // "2px solid black",
          ...(blockId && !isDashboard ? { width: 'max-content' } : {}),
        }}
        id={`table-${blockId}`}
      >
        <Loading loading={isTableLoading} hasTip>
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          {memoTable}
        </Loading>
      </div>
    );
};

export default UniversalTable;